import { AudioEngineIncompatiblePeerWarningDialogData, RoomContext, RoomContextType } from '../RoomContext'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { DialogBody, DialogTitle } from '@/components/Dialog'
import { useContext, useRef } from 'react'
import useRoomContextRef from '../services/useRoomContextRef'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import CaretRightIcon from '@/CustomIcons/CaretRightIcon'

export default function AudioEngineIncompatiblePeerWarningDialog({
    data,
    onClose,
}: {
    data: AudioEngineIncompatiblePeerWarningDialogData
    onClose: () => void
}) {
    const { dispatch: roomDispatch } = useContext(RoomContext) as RoomContextType

    const { roomStateRef } = useRoomContextRef()

    const doNotShowAgainRef = useRef(false)

    const onOk = (doNotShowAgain: boolean) => {
        doNotShowAgainRef.current = doNotShowAgain

        let next = { isOpen: false, doNotShowAgain: doNotShowAgain, incompatiblePeers: [], audioengineLabel: '' }
        roomDispatch({
            type: 'update_room_context',
            value: { audioEngineIncompatiblePeerWarningDialog: next },
        })
        onClose()
    }

    const onCloseDialog = () => {
        // NOTE: this gets called even though the user clicks either of the positive/negative buttons.
        const next = { ...roomStateRef.current.audioEngineIncompatiblePeerWarningDialog }
        next.isOpen = false
        next.doNotShowAgain = doNotShowAgainRef.current

        roomDispatch({
            type: 'update_room_context',
            value: { audioEngineIncompatiblePeerWarningDialog: next },
        })
    }

    return (
        <CrossPlatformDialog frameName="Dialog:AudioEngineIncompatiblePeerWarningDialog" onDefaultClose={onCloseDialog}>
            <DialogBody>
                <DialogTitle>Warning: Collaborator incompatible with pro audio</DialogTitle>

                <div className="pb-4">
                    The following user(s) are using older versions of Muse compatible with Pro Audio. They will not be
                    able to hear your Pro Audio devices.
                </div>

                <div className="pb-4">
                    {data.incompatiblePeers.map((peer, i) => {
                        return (
                            <div className="ml-4" key={i}>
                                <CaretRightIcon />
                                {peer.username} (Version {peer.appVersion})
                            </div>
                        )
                    })}
                </div>

                <div>Pro Audio is available in Muse 2.0 and above.</div>
            </DialogBody>
            <DialogActionButtonsSection
                rightButtonText="OK"
                onRightButtonClicked={() => onOk(false)}
                leftButtonText="Do not show again"
                onLeftButtonClicked={() => onOk(true)}
            />
        </CrossPlatformDialog>
    )
}
